import { ApiType } from "@gymflow/common";
import { ActivityStatus, PaginationOptions } from "@gymflow/types";
import { useQuery } from "@tanstack/react-query";

import { appointableAsCustomerQueryKeys } from "./appointableAsCustomerQueryKeys";

export function useQueryAppointableCategoriesAsMember(
  {
    api,
    paginationOption,
    filter,
  }: {
    api: ApiType;
    paginationOption: PaginationOptions;
    filter?: {
      statusList?: ActivityStatus[];
    };
  },
  {
    enabled,
  }: {
    enabled?: boolean;
  } = {
    enabled: true,
  },
) {
  return useQuery({
    queryKey: appointableAsCustomerQueryKeys.categories({
      ...paginationOption,
      ...filter,
    }),
    queryFn: async () =>
      (
        await api.customerAppointableApi.fetchCategories({
          ...paginationOption,
          ...filter,
        })
      ).data,
    enabled,
  });
}
